import { yup } from '@guiker/shared-framework'

import { AgreementFeeType } from '../../../../entity'
import { rentalFeeSchema } from './rental-fee-schema'

const assetSchema = yup.object({ id: yup.string().required() })
const assetsSchema = yup.array().of(assetSchema)

export const updatePropRentalAgreementSchema = yup.object<{
  contractId?: string
  assets?: { id: string }[]
  onboarding?: {
    started?: string
    expired?: string
  }
  newLease: {
    type: AgreementFeeType
    value: number
  }
  renewal: {
    type: AgreementFeeType
    value: number
  }
  sublease: {
    type: AgreementFeeType
    value: number
  }
}>({
  contractId: yup
    .string()
    .nullable()
    .transform((v) => (!!v ? v : null)),
  assets: assetsSchema,
  onboarding: yup.object({
    started: yup
      .string()
      .nullable()
      .transform((v) => (!!v ? v : null)),
    expired: yup
      .string()
      .nullable()
      .transform((v) => (!!v ? v : null)),
  }),
  newLease: rentalFeeSchema.required(),
  renewal: rentalFeeSchema.required(),
  sublease: rentalFeeSchema.required(),
})
